import React from 'react'

interface AmountInputBoxProps {
    label: string;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string | number;
    name: string;
    disabled?: boolean;

}
const AmountInputBox: React.FC<AmountInputBoxProps> = ({ label, disabled, value, name, handleChange }) => {
    return (
        <div className='flex float-end gap-2'>
            <label htmlFor="" className='text-sky-900 text-opacity-70 font-medium dark:text-slate-400 text-[12px]'>{label}: </label>
            <input onChange={handleChange} disabled={disabled} value={value} name={name} className='w-16 ring-[1px] text-[12px] ring-slate-300 dark:bg-transparent dark:ring-sky-700 rounded-sm focus:outline-none focus:ring-green-600 text-green-500 px-2 py-0.5 text-start'
                type="number" />
        </div>
    )
}

export default AmountInputBox